var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{class:{ 'error--text': _vm.error }},[_vm._v(" "+_vm._s(_vm.fmt())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }